/**
 * The Pressentia lockup, as a themed element rather than an `<img>`.
 *
 * The lockups are drawn for a background, not for a theme: the light one has a navy wordmark that
 * vanishes on the dark ground, and the navy one has a white wordmark that vanishes on paper. That
 * swap belongs in CSS beside the theme it follows — an `<img src>` chosen in JS would have to read
 * `data-theme` on every render and would still flash the wrong file on first paint.
 *
 * `role="img"` with a label because the mark carries the product's name: a screen reader that skips
 * it reads a masthead with no masthead in it.
 */
export function BrandLogo({ variant, className }: { variant: 'horizontal' | 'mark'; className?: string }) {
  return <span role="img" aria-label="Pressentia" className={`brandLogo brandLogo--${variant}${className ? ` ${className}` : ''}`} />;
}
